import PropTypes from 'prop-types'
import React from 'react'
import { Badge, Card, CardBody, Col, Row } from 'reactstrap'
import { formatPhase3Date, formatPhase3Money } from '../helpers/phase3-inbound-journey-helper'

const propTypes = {
  product         : PropTypes.object,
  showBuyingPrice : PropTypes.bool
}

const defaultProps = {
  product         : {},
  showBuyingPrice : true
}

const missingFieldLabel = (field) => ({
  photo_folder_link              : 'Google Drive photo folder link',
  condition_id                   : 'Condition',
  supplier_name                  : 'Consignor name',
  price_tag_done                 : 'Price tag done',
  description_or_stamp_or_leather: 'Description / stamp / leather',
  comes_with                     : 'Comes with',
  condition_note                 : 'Defects / condition note',
  size                           : 'Size',
  details_or_measurements        : 'Details / measurements',
  selling_price                  : 'Selling price',
  default_price                  : 'Default price',
  appraisal_state                : 'Appraisal approval',
  item_location_id               : 'Lokasi Produk',
  stockist_pic                   : 'PIC Stockist (Foto Detail)'
}[field] || field)

const renderMissingGroup = (title, fields = []) => (
  <Col md='4' className='mb-3 mb-md-0'>
    <div className='d-flex align-items-center mb-2'>
      <Badge color={ fields.length > 0 ? 'warning' : 'success' } className='mr-2'>
        { fields.length > 0 ? `${fields.length} missing` : 'Ready' }
      </Badge>
      <div className='small text-muted'>{ title }</div>
    </div>
    <div>
      { fields.length > 0 ? fields.map(missingFieldLabel).join(', ') : '-' }
    </div>
  </Col>
)

const Phase3ProductSummaryCard = ({ product, showBuyingPrice }) => {
  const missingStudio = product.inbound_journey_missing_studio_fields || []
  const missingPriceTag = product.inbound_journey_missing_price_tag_fields || []
  const missingLive = product.inbound_journey_missing_live_fields || []

  return (
    <Card className='mb-3'>
      <CardBody>
        <Row>
          <Col md='7'>
            <h3 className='mb-1'>{ product.sku || '-' }</h3>
            <h4 className='font-weight-normal'>{ product.name || '-' }</h4>
            <p className='text-muted mb-2'>
              { [ product.designer_name, product.category_name, product.condition_name ].filter(Boolean).join(' / ') || '-' }
            </p>
            <Badge color={ product.price_tag_done ? 'success' : 'warning' }>
              Price tag done: { product.price_tag_done ? 'Yes' : 'No' }
            </Badge>
          </Col>
          <Col md='5'>
            <Row>
              <Col md='6' className='mb-2'>
                <div className='small text-muted'>Consignor</div>
                <div className='font-weight-bold'>{ product.supplier_name || product.consignment?.consignor_detail?.formatted_name || product.consignment?.consignor?.name || '-' }</div>
              </Col>
              <Col md='6' className='mb-2'>
                <div className='small text-muted'>Last update</div>
                <div>{ formatPhase3Date(product.updated_at) }</div>
              </Col>
            </Row>
            { showBuyingPrice && (
              <Row>
                <Col md='4' className='mb-2'>
                  <div className='small text-muted'>Buying Price</div>
                  <div className='font-weight-bold'>{ formatPhase3Money(product.buying_price) }</div>
                </Col>
                <Col md='4' className='mb-2'>
                  <div className='small text-muted'>Default Price</div>
                  <div className='font-weight-bold'>{ formatPhase3Money(product.default_price) }</div>
                </Col>
                <Col md='4' className='mb-2'>
                  <div className='small text-muted'>Selling Price</div>
                  <div className='font-weight-bold'>{ formatPhase3Money(product.selling_price) }</div>
                </Col>
              </Row>
            ) }
          </Col>
        </Row>

        <hr />

        <Row>
          { renderMissingGroup('Studio missing', missingStudio) }
          { renderMissingGroup('Price tag missing', missingPriceTag) }
          { renderMissingGroup('Live missing', missingLive) }
        </Row>
      </CardBody>
    </Card>
  )
}

Phase3ProductSummaryCard.propTypes = propTypes
Phase3ProductSummaryCard.defaultProps = defaultProps

export default Phase3ProductSummaryCard
